export const dishesListDataSelector = state => state.dishes.listData;

export const dishesStepSelector = state => state.dishes.formStep;
export const dishesCompletedStepsSelector = state => state.dishes.completedSteps;

export const dishItemSelector = state => state.dishes.currentItem;
export const dishItemLoadingSelector = state => state.dishes.itemLoading;

export const createOrUpdateInProcessSelector = state => state.dishes.createOrUpdateInProcess;
export const createOrUpdateErrorsSelector = state => state.dishes.errors;

export const deleteInProcessSelector = state => state.dishes.deleteInProcess;
